import React from 'react';
import { CallCta, StartCta } from './CtaButton';
export function Hero() {
  return <section className="bg-brand-black text-brand-white" data-id="element-41" data-mp="ek68ouphyeaw">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-12 sm:px-8 sm:pb-20 sm:pt-16 lg:pb-28 lg:pt-20" data-id="element-42" data-mp="eilgvcukh9gq">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-center lg:gap-16" data-id="element-43" data-mp="9ipax82b77yj">
          <div data-id="element-44" data-mp="4jvx1ej41exu">
            <p className="inline-block border-l-4 border-brand-red pl-3 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-white sm:text-xs" data-id="element-45" data-mp="1297cu5rar3ad">
              72-Hour Launch — Limited Time
            </p>

            <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tight sm:text-5xl lg:text-[4.25rem]" data-id="element-46" data-mp="sartioyigybf">
              Your Business, Online in{' '}
              <span className="text-brand-red" data-id="element-47" data-mp="3d1ik78o21amw">72 Hours</span>
              <br className="hidden sm:block" data-id="element-48" data-mp="3d33fj0i70xlt" /> — Not 3 Months
            </h1>

            <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-light sm:text-lg" data-id="element-49" data-mp="381e0zavri1sz">
              Most agencies take months to build your website. We build the shell of yours in 72
              hours — then you just message changes through Slack and our AI (MISTR) makes them.{' '}
              <span className="font-semibold text-brand-white" data-id="element-50" data-mp="399bb9nvh7dvz">
                No developer, no waiting, no hassle.
              </span>
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-51" data-mp="30i18d5yke5em">
              <StartCta size="lg" data-id="element-52" data-mp="30g6kbirzxx6b" />
              <CallCta size="lg" variant="onDark" data-id="element-53" data-mp="358zr0c70zfl1" />
            </div>

            <p className="mt-5 text-sm text-brand-gray" data-id="element-54" data-mp="2qjv8etwbj9ce">
              Site shell live in 72 hours · 3-month minimum term
            </p>
          </div>

          <div className="lg:pl-6" data-id="element-55" data-mp="2vjpzoyk0a0xz">
            <div className="border-l-2 border-brand-red pl-6" data-id="element-56" data-mp="2vglld8cttotl">
              <p className="font-display text-7xl font-extrabold leading-none text-brand-white sm:text-8xl" data-id="element-57" data-mp="2hjoy1gvx2phg">
                72
              </p>
              <p className="mt-2 font-display text-xl font-bold uppercase tracking-[0.2em] text-brand-red" data-id="element-58" data-mp="s21hwapu6bzg">
                Hours
              </p>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-brand-light" data-id="element-59" data-mp="najihr3gojgl">
                From kickoff call to a live site shell you can look at, click through, and start
                sending changes for.
              </p>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-brand-white/15 pt-8" data-id="element-60" data-mp="1b0nk5sx3a94y">
              <div data-id="element-61" data-mp="1622l3wtkpvi3">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-62" data-mp="162uer23m1j5q">
                  Changes
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-63" data-mp="114swukhx7pvu">
                  Message them in Slack
                </dd>
              </div>
              <div data-id="element-64" data-mp="3lu03r3mln90s">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-65" data-mp="3lui86njf0tjs">
                  Who does them
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-66" data-mp="1x9kwssxc7gkd">MISTR, our AI</dd>
              </div>
              <div data-id="element-67" data-mp="21a4rlpufu83c">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-68" data-mp="21bplrecubp0o">
                  Phones
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-69" data-mp="26868c44e5vbn">
                  AI attendant, 24/7
                </dd>
              </div>
              <div data-id="element-70" data-mp="2fz0wje1774zq">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-71" data-mp="2fzj2j2dnwxku">
                  Leads
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-72" data-mp="2p0qp4n6tg9z3">
                  Your own CRM account
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>;
}